import React, { useState } from 'react';
import moment from 'moment';
import { Button, Typography } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import parse from 'html-react-parser';
import { getContent } from '../../../services';
import TabInformasiTol from './TabInformasiTol';

const useStylesMain = makeStyles((theme: Theme) =>
  createStyles({
    rowHeight: {
      maxHeight: '7.5em',
      overflow: 'hidden',
      '& p': {
        lineHeight: '1.5em',
      },
    },
  })
);

const CrudInformasiTol = ({ title, type }: any) => {
  const classes = useStylesMain();
  const initAddState = { open: false, action: 'Add' };
  const [actionState, setActionState] = useState(initAddState);
  const [editState, setEditState] = useState<any>(null);
  return (
    <>
      {actionState.open ? (
        <TabInformasiTol
          title={title}
          type={type}
          action={actionState.action}
          onCancel={() => setActionState(initAddState)}
          data={editState}
        />
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              marginBottom: '1rem',
            }}
          >
            <Button
              variant='contained'
              color='primary'
              size='large'
              onClick={() => {
                setEditState(null);
                setActionState({ open: true, action: 'Add' });
              }}
              startIcon={<Add />}
            >
              Add
            </Button>
          </div>
          <MaterialTable
            columns={[
              {
                title: 'Tahap',
                field: 'place',
                align: 'center',
                render: (rowData) => (
                  <Typography style={{ fontWeight: 700 }}>
                    {rowData.place}
                  </Typography>
                ),
              },
              {
                title: 'Title ID',
                field: 'title_id',
                render: (rowData) => (
                  <Typography variant='body2' className={classes.rowHeight}>
                    {rowData.title_id}
                  </Typography>
                ),
              },
              {
                title: 'Title EN',
                field: 'title_en',
                render: (rowData) => (
                  <Typography variant='body2' className={classes.rowHeight}>
                    {rowData.title_en}
                  </Typography>
                ),
              },
              {
                title: 'Image',
                field: 'image',
                width: '10%',
                render: (rowData) => (
                  <img
                    src={`${process.env.REACT_APP_URL}/images/${rowData.image}`}
                    alt={rowData.image}
                    width={30}
                  />
                ),
              },
              {
                title: 'Content ID',
                field: 'content_id',
                render: (rowData) => (
                  <div className={classes.rowHeight}>
                    {parse(rowData.content_id)}
                  </div>
                ),
              },
              {
                title: 'content EN',
                field: 'content_en',
                render: (rowData) => (
                  <div className={classes.rowHeight}>
                    {parse(rowData.content_en)}
                  </div>
                ),
              },
              {
                title: 'Second Title ID',
                field: 'sub_title_id',
                render: (rowData) => (
                  <Typography variant='body2' className={classes.rowHeight}>
                    {rowData.sub_title_id}
                  </Typography>
                ),
              },
              {
                title: 'Second Title EN',
                field: 'sub_title_en',
                render: (rowData) => (
                  <Typography variant='body2' className={classes.rowHeight}>
                    {rowData.sub_title_en}
                  </Typography>
                ),
              },

              {
                title: 'Third Title ID',
                field: 'second_sub_title_id',
                render: (rowData) => (
                  <Typography variant='body2' className={classes.rowHeight}>
                    {rowData.second_sub_title_id}
                  </Typography>
                ),
              },
              {
                title: 'Third Title EN',
                field: 'second_sub_title_en',
                render: (rowData) => (
                  <Typography variant='body2' className={classes.rowHeight}>
                    {rowData.second_sub_title_id}
                  </Typography>
                ),
              },
              {
                title: 'Second Content ID',
                field: 'sub_content_id',
                render: (rowData) => (
                  <div className={classes.rowHeight}>
                    {parse(rowData.sub_content_id)}
                  </div>
                ),
              },
              {
                title: 'Second content EN',
                field: 'sub_content_en',
                render: (rowData) => (
                  <div className={classes.rowHeight}>
                    {parse(rowData.sub_content_en)}
                  </div>
                ),
              },
              {
                title: 'Created',
                field: 'created_at',
                align: 'right',
                render: (rowData) =>
                  moment(rowData.created_at).format('YYYY-MM-DD HH:mm'),
              },
            ]}
            title={
              <Typography
                variant='h6'
                color='primary'
                style={{ fontWeight: 600 }}
              >
                List {title}
              </Typography>
            }
            data={(query) =>
              new Promise((resolve) => {
                const { pageSize, page, search } = query;
                getContent(type, pageSize, page + 1, search).then((result) => {
                  resolve({
                    data: result.data.rows,
                    page: Number(result.data.page - 1),
                    totalCount: Number(result.data.total),
                  });
                });
              })
            }
            onRowClick={(event, rowData) => {
              setEditState(rowData);
              setActionState({ open: true, action: 'Edit' });
            }}
          />
        </>
      )}
    </>
  );
};

export default CrudInformasiTol;
